// TO-DO
// для компонентов, которые используются на всех стр

import Title from "@/components/ui-kit/Title";

export default [Title];
